import React from 'react'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import useTableFixedHeader from 'hooks/useTableFixedHeader'
import { superAxiosRequest } from 'axiosApi'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import THead from 'components/ContentBox/Global/ReportTable/THead'
import st from 'components/ContentBox/Global/ReportTable/Table.module.scss'
import Filter from '../../../ContentBox/Global/Filter/Filter'
import { dateFormat } from 'helpers/date'
import { ExcelRowsParams } from '../../../utils/ExcelExport'
import ExportExcelButton from '../ExportExcelButton/ExportExcelButton'

const MailingToClientsReport = () => {
  const {
    refWrapper,
    refSticky,
    refThead,
    data,
    setData,
    isLoading,
    setIsLoading,
  } = useTableFixedHeader()

  const filterCnf = [
    {
      type: 'days-range-picker',
      data: {
        date_from: new Date(new Date().setDate(1)),
        date_until: new Date(
          new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0),
        ),
      },
      nameState: ['date_from', 'date_until'],
    },
  ]

  const cols = [
    { name: 'Ф.И.О' },
    { name: 'Дата рождения' },
    { name: 'Телефон' },
    { name: 'Абонемент' },
  ]

  const sendRequest = (params) => {
    setIsLoading(true)
    let apiConf = {
      method: 'get',
      params: {
        ...params,
      },
    }
    if (apiConf.params.date_from)
      apiConf.params.date_from = dateFormat(
        new Date(apiConf.params.date_from),
        'YYYY-mm-dd',
      )
    if (apiConf.params.date_until)
      apiConf.params.date_until = dateFormat(
        new Date(
          apiConf.params.date_until.getFullYear(),
          apiConf.params.date_until.getMonth() + 1,
          0,
        ),
        'YYYY-mm-dd',
      )
    superAxiosRequest({
      ...apiConf,
      link: 'unidance/client_subscription_zero',
    }).then((res) => {
      setData(res.data.result)
      setIsLoading(false)
    })
  }
  const getData = () => {
    setIsLoading(true)
    superAxiosRequest({
      method: 'get',
      link: 'unidance/client_subscription_zero',
      params: {
        date_from: dateFormat(new Date(new Date().setDate(1)), 'YYYY-mm-dd'),
      },
    })
      .then((res) => {
        setData(res.data.result)
        setIsLoading(false)
      })
      .catch(() => setIsLoading(false))
  }

  const downloadExcel = (data) => {
    import('xlsx-js-style').then((XLSX) => {
      const headRow = [
        {
          v: 'Ф.И.О. студента',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Дата рождения',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Телефон',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Абонемент',
          ...ExcelRowsParams.headerRowParam,
        },
      ]
      let tableData = []
      let merges = []
      let wscols = [{ wch: 40 }, { wch: 30 }, { wch: 30 }, { wch: 50 }]
      let rows = [{ hpx: 30 }]
      data.forEach((item) => {
        tableData.push([
          {
            v: `${item.full_name}`,
            ...ExcelRowsParams.tableRowParam.firstCell,
          },
          {
            v: `${item.client_birthday}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${item.client_phone}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${item.subscription_name}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
        ])
      })

      let wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet([headRow, ...tableData])
      ws['!cols'] = wscols
      ws['!merges'] = merges
      ws['!rows'] = rows
      XLSX.utils.book_append_sheet(wb, ws, 'List 1')

      XLSX.writeFile(wb, 'Нулевой баланс абонемента.xlsx')
    })
  }
  return (
    <div>
      <ContentHeader title='Нулевой баланс абонемента' />
      <Filter
        config={filterCnf}
        getFilterParams={(e) => sendRequest(e)}
        drop={() => getData()}
      />
      {isLoading ? (
        <Loader />
      ) : !Array.isArray(data) ? (
        <h1 style={{ textAlign: 'center' }}>Нет данных для отображения!</h1>
      ) : (
        <>
          <div className={st.tableWrapper} ref={refWrapper}>
            <div ref={refSticky} className={st.sticky}>
              <table className={st.table}>
                <THead cols={cols} />
              </table>
            </div>
            <table className={`${st.table} ${st.tbodyStriped}`}>
              <THead cols={cols} ref={refThead} />
              <tbody className={st.tbody}>
                {Array.isArray(data) && (
                  <>
                    {data.map((row, rowIdx) => (
                      <tr key={rowIdx} className={st.bdt}>
                        <td className={st.fw600}>
                          <div
                            className={`${st.groupDescription} ${st.medium}`}
                          >
                            {row.full_name}
                          </div>
                        </td>
                        <td className={`${st.tdMiddle} ${st.textAlignCenter}`}>
                          <div
                            className={`${st.groupDescription} ${st.medium}`}
                          >
                            {row.client_birthday}
                          </div>
                        </td>
                        <td className={`${st.tdMiddle} ${st.textAlignCenter}`}>
                          <div
                            className={`${st.groupDescription} ${st.bottom}`}
                          >
                            {row.client_phone}
                          </div>
                        </td>
                        <td className={`${st.tdMiddle} ${st.textAlignCenter}`}>
                          <div
                            className={`${st.groupDescription} ${st.bottom}`}
                          >
                            {row.subscription_name}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div style={{ padding: '10px' }}>
            <ExportExcelButton data={data} downloadExcel={downloadExcel} />
          </div>
        </>
      )}
    </div>
  )
}

export default MailingToClientsReport
